"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calendar_1 = require("../icons/calendar");
exports.default = calendar_1.Calendar;
